module.exports = __webpack_public_path__ + "images/places/training_653-d6fee79933c67334d59cfdd273ead284.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_653.jpg
 ** module id = 320
 ** module chunks = 0
 **/